/**
 * @typedef {Object} FontOption
 * @property {string} name - Display name of the font
 * @property {string} value - CSS font-family value
 * @property {boolean} [isCustom] - Whether this is a custom uploaded font
 */

/**
 * @typedef {Object} CustomFont
 * @property {string} name - Name of the custom font
 * @property {string} data - Base64 data URL of the font file
 * @property {string} fileName - Original filename
 * @property {string} uploadDate - ISO date string when uploaded
 */

/**
 * @typedef {Object} FontSettings
 * @property {FontOption} displayHeading - Font for h1, main titles
 * @property {FontOption} headings - Font for h2, h3, h4, h5, h6
 * @property {FontOption} subheading - Font for page subheadings and descriptions
 * @property {FontOption} body - Font for paragraphs, main content
 * @property {FontOption} ui - Font for buttons, labels, interface elements
 */

/**
 * @typedef {Object} GlobalFontSettings
 * @property {FontSettings} fonts - Font settings for different categories
 * @property {CustomFont[]} customFonts - Array of custom uploaded fonts
 * @property {number} fontSize - Base font size in pixels
 */

export const DEFAULT_FONT_OPTIONS = [
  { name: "Parisienne", value: "'Parisienne', cursive" },
  { name: "Crimson Text", value: "'Crimson Text', Georgia, serif" },
  { name: "Playfair Display", value: "'Playfair Display', Georgia, serif" },
  { name: "Lora", value: "'Lora', Georgia, serif" },
  { name: "Merriweather", value: "'Merriweather', Georgia, serif" },
  { name: "EB Garamond", value: "'EB Garamond', Georgia, serif" },
  { name: "Cormorant Garamond", value: "'Cormorant Garamond', Georgia, serif" },
  { name: "Source Serif Pro", value: "'Source Serif Pro', Georgia, serif" },
  { name: "DM Serif Display", value: "'DM Serif Display', Georgia, serif" },
  {
    name: "Inter",
    value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  {
    name: "System Sans",
    value:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  },
];

export const DEFAULT_FONT_SETTINGS = {
  displayHeading: {
    name: "DM Serif Display",
    value: "'DM Serif Display', Georgia, serif",
  },
  headings: {
    name: "Playfair Display",
    value: "'Playfair Display', Georgia, serif",
  },
  subheading: {
    name: "Lora",
    value: "'Lora', Georgia, serif",
  },
  body: { name: "Lora", value: "'Lora', Georgia, serif" },
  ui: {
    name: "Inter",
    value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
};
